import UserDonutChart from './UserDonutChart';

export default UserDonutChart;
